import React, { useContext, useEffect } from "react";
import { Layout } from "flexlayout-react";
import "flexlayout-react/style/light.css";
import { LocalStoreContext } from "../store/LocalStore";
import { StoreContext } from "../../../store/Store";
import { onlyUnique } from "../../../utils/dataFunctions";
import { LayoutContext } from "../store/LayoutContext";
import { GlobalRefContext } from "../../../store/GlobalRefs";
import { RefContext } from "../store/RefContext";
import { actionTypes as lactionTypes } from "../store/storeTypes";
import { vsfpData } from "../../../api/s3";
import palettedata from "../../../data/palette.json";
import {
  onAction,
  factory,
  layoutModelChange,
  onRenderTabSet,
  onRenderTab,
} from "./layoutFunctions";
import "../../../layout/layoutstyle.css";

const palette = palettedata.map((item) => item["hex code"]);

// const palette = [
//   "#477CA8",
//   "#9FCCEA",
//   "#F48C2B",
//   "#FDBD78",
//   "#5AA04E",
//   "#8CD07F",
//   "#B89434",
//   "#F1CD62",
//   "#489B95",
//   "#87BCB3",
// ];

const filterKeys = ["ModelDate", "Ticker", "Horizon"];

export const VSFPLayout = () => {
  const [store] = useContext(StoreContext);
  const [lstore, ldispatch] = useContext(LocalStoreContext);
  const [layoutState, setLayoutState] = useContext(LayoutContext);
  const refs = useContext(RefContext);
  const grefs = useContext(GlobalRefContext);

  const { auth, debug } = store;

  if (debug) {
    console.log("VSFPLayout");
  }

  if (lstore) {
    //do nothing
  }

  useEffect(() => {
    let isCancelled = false;

    const asyncfunction = async () => {
      ldispatch({ type: lactionTypes.SET_LOADING, payload: true });
      const newState = {
        rawdata: [],
      };

      const sdata = await vsfpData(auth, grefs.tickerStorage.current);

      if (sdata && sdata.length > 0) {
        newState.rawdata = sdata;

        const sortAlphaNum = (a, b) =>
          a.localeCompare(b, "en", { numeric: true });

        const defaults = filterKeys.reduce((a, b) => {
          return {
            ...a,
            [b]: newState.rawdata
              .map((item) => (item[b] === null ? "" : item[b].toString()))
              .filter(onlyUnique)
              .sort(sortAlphaNum),
          };
        }, {});

        defaults.Ticker.sort().forEach((item, i) => {
          refs.tickerPalette.current[item] = palette[i];
        });

        defaults.ModelDate.sort((a, b) => {
          return new Date(b) - new Date(a);
        });

        defaults["ModelDate"].unshift("All");
        defaults["Ticker"].unshift("All");

        ldispatch({
          type: lactionTypes.SET_FILTER_DEFAULTS,
          payload: JSON.parse(JSON.stringify(defaults)),
        });
        ldispatch({
          type: lactionTypes.SET_FILTER,
          payload: {
            Ticker: [...defaults.Ticker],
            ModelDate: [...defaults.ModelDate],
            Horizon: ["21"],
          },
        });
      }

      if (!isCancelled) {
        ldispatch({ type: lactionTypes.SET_VSFP, payload: newState });
        ldispatch({ type: lactionTypes.SET_LOADING, payload: false });
      }
    };
    asyncfunction();

    return () => {
      isCancelled = true;
    };
  }, [auth, ldispatch, grefs.tickerStorage, refs.tickerPalette]);

  if (layoutState.model) {
    return (
      <Layout
        ref={layoutState.layout}
        model={layoutState.model}
        factory={factory}
        onRenderTabSet={(tabSetNode) => onRenderTabSet(tabSetNode, refs)}
        onModelChange={(model) =>
          layoutModelChange(model, layoutState, setLayoutState, grefs)
        }
        onAction={(action) => onAction(action, layoutState)}
        onRenderTab={(node, renderState) =>
          onRenderTab(node, renderState, refs.componentSize)
        }
      />
    );
  } else return null;
};
